import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { ChallengeScreenError } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import { VIEW_NAME } from '../../constants/login-constant';
import {
  ResetPasswordUserRequest,
  ResetPasswordUserResponse
} from '../../models/reset-password-api.interface';
import { ResetPasswordSupportExtendedFacade } from './reset-password-support-extended.facade';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordSupportFacade extends ResetPasswordSupportExtendedFacade {
  unsubscribe: Subject<void> = new Subject<void>();
  authConfig = {} as OauthAEMConfig;
  apiResponse = {} as ResetPasswordUserResponse;

  onResetPasswordFormSubmitBff() {
    const requestObj: ResetPasswordUserRequest =
      this.resetPasswordadapter.setUserRequestObj(
        this.getResetPasswordContent()
      );
    this.resetPasswordApiService
      .getUserData(requestObj)
      .pipe(
        takeUntil(this.unsubscribe),
        switchMap((response) =>
          this.pingOauthService.getAuthConfigContent().pipe(
            map((authConfig) => {
              this.authConfig = authConfig;
              this.apiResponse = response;
              return { authConfig, response };
            })
          )
        )
      )
      .subscribe(
        ({ authConfig, response }) => {
          if (response?.errors && response.errors.length > 0) {
            this.handleNewResetPasswordError(authConfig, response);
            return;
          }
          this.redirectToNewResetPassword(authConfig, response);
        },
        (error: HttpErrorResponse | ChallengeScreenError) => {
          this.pingOauthService
            .getAuthConfigContent()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((authConfig) => {
              if (authConfig.ERROR_428) {
                if (error instanceof ChallengeScreenError) {
                  this.loggingService.log(
                    'Status Code: 428 - Display Code Challenge: ' + error
                  );
                } else {
                  this.checkRedirectNewPassword(error, authConfig);
                }
              } else {
                this.checkRedirectNewPassword(error, authConfig);
              }
            });
        }
      );
  }

  checkRedirectNewPassword(
    err: HttpErrorResponse | ChallengeScreenError,
    authConfig: OauthAEMConfig
  ) {
    if (authConfig.NEW_RESET_PASSWORD_FLOW) {
      if (!err?.error?.errors) {
        this.redirectToNewResetPassword(authConfig, this.apiResponse, true);
        return;
      }
    }
    this.handleError(err?.error?.errors);
  }

  redirectToNewResetPassword(
    authConfig: OauthAEMConfig,
    response: ResetPasswordUserResponse,
    skipSqaContent = false
  ) {
    this.setResetPasswordFormValues(skipSqaContent);
    this.resetForm();
    this.initiateNewResetPassword(authConfig, response);
  }

  initiateNewResetPassword(
    authConfig: OauthAEMConfig,
    response: ResetPasswordUserResponse
  ) {
    this.setActionButtonDisable(false);

    if (authConfig?.NEW_RESET_PASSWORD_FLOW) {
      if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
        this.wifiPortalService.getRefreshUrlWFP();
        this.checkForSQAScreenDisplayHelper();
        this.analytics.dispatchCustomEvent(
          ANALYTICS_EVENTS_LOGIN.SECURITY_QUESTIONS_ANSWERS_LOADED,
          true
        );
        this.nextDisplayViewService.nextDisplayView(
          VIEW_NAME.SECURITY_QUESTION_ANSWER_SCREEN
        );
      } else {
        this.analytics.dispatchCustomEvent(
          ANALYTICS_EVENTS_LOGIN.CHECK_YOUR_EMAIL_RP_LOADED,
          true
        );
        this.checkEmailFacadeService.resetErrors();
        this.nextDisplayViewService.nextDisplayView(
          VIEW_NAME.NEW_RESET_PASSWORD_CHECK_YOUR_EMAIL_SCREEN
        );
      }
    } else {
      this.handleSuccess(response);
    }
  }
}
